import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox, Input } from "antd";
import { IconSearch } from "../../../../../asset";
import { POSTGetInitiateServices } from "../../../../../service/PostGetInitiateServices";
import { POSTGetListServices } from "../../../../../service/POSTGetListServices";
import { setGlobalCustomerReport } from "../../../../../store/reducer/globalMultipleSearchSelect.reducer";

const MSSCustomerReport = ({
  setValueMSS,
  valueMSS,
  children,
  togglerClassName,
  placeholder,
  className,
  ...attrs
}) => {
  const { token } = useSelector((state) => state.auth);
  const { globalDepotName } = useSelector((state) => state.globalMSS);
  const dispatch = useDispatch();

  const dropdownRef = useRef(null);
  const dropdownContentRef = useRef(null);
  const btnDropdownRef = useRef(null);
  const [isShowDropdownContent, setIsShowDropdownContent] = useState(false);
  const [listData, setListData] = useState([]);
  const [listSelected, setListSelected] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [totalData, setTotalData] = useState(null);
  const [isSelectedAll, setIsSelectedAll] = useState(false);
  const [params, setParams] = useState();

  const togglerDropdownContent = useCallback(() => {
    setIsShowDropdownContent((state) => !state);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (
        dropdownRef?.current &&
        !dropdownRef?.current.contains(event?.target) &&
        dropdownContentRef?.current?.classList.contains("active")
      ) {
        setIsShowDropdownContent(false);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document?.removeEventListener("click", handleClick);
    };
  }, []);

  const isDepotHasValue = useMemo(() => {
    if (globalDepotName && globalDepotName.length === 0) {
      return false;
    }
    return true;
  }, [globalDepotName]);

  const getTotalData = useCallback(async () => {
    const payload = {
      page: 1,
      limit: 10,
      order: "",
      filter: "",
      connector: "",
      other: {
        depot: {
          list_id: [-1],
          exclude: false,
        },
      },
    };

    const resInitiate = await POSTGetInitiateServices(
      token,
      `customer/dropdown-report`,
      payload
    );
    if (resInitiate?.success && resInitiate?.initiate !== null) {
      setTotalData(resInitiate?.initiate?.count_data);
      return;
    }
    setTotalData(null);
  }, [token]);

  useEffect(() => {
    getTotalData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getListCustomer = useCallback(
    async (newParams) => {
      const depots = [...globalDepotName];
      const newDepot =
        depots && depots.length === 0
          ? {
              depot: {
                list_id: [-1],
                exclude: false,
              },
            }
          : depots && depots.includes(-1)
          ? {
              depot: {
                list_id: [-1],
                exclude: false,
              },
            }
          : {
              depot: {
                list_id: depots?.map((el) => el?.id),
                exclude: false,
              },
            };

      const payload = {
        page: newParams?.page,
        limit: newParams?.limit,
        order: "",
        filter: newParams?.filter,
        connector: "",
        other: newDepot,
      };

      const res = await POSTGetListServices(
        token,
        `customer/dropdown-report`,
        payload
      );

      if (res?.success && res?.list !== null) {
        const list = res?.list.map((el) => {
          return {
            id: el?.customer_id,
            cust_name: `${el?.first_name} ${el?.last_name}`,
          };
        });

        if (newParams?.filter && newParams?.filter.includes("customer_name")) {
          setListData([...list]);
          return;
        }
        list.unshift({ id: -1, cust_name: "Select All" });
        setListData([...list]);
      }
      if (res?.success && res?.list === null) {
        setListData([{ id: -1, cust_name: "Select All" }]);
      }
    },
    [globalDepotName, token]
  );

  const handleClickSelectData = useCallback(
    (item) => {
      if (item?.id === -1) {
        if (listSelected.length === 0 || !listSelected) {
          setListSelected([-1]);
          dispatch(setGlobalCustomerReport([-1]));
          return;
        }
        if (listSelected.length && listSelected.length - 1 !== totalData) {
          if (listSelected.includes(-1)) {
            setListSelected([]);
            dispatch(setGlobalCustomerReport([]));
            return;
          }
          setListSelected([-1]);
          dispatch(setGlobalCustomerReport([-1]));
          return;
        }
        if (listSelected.length && listSelected.includes(-1)) {
          setListSelected([]);
          dispatch(setGlobalCustomerReport([]));
        }

        return;
      }
      if (item?.id !== -1) {
        if (listSelected.length === 0) {
          const listDataSelected = listSelected;
          listDataSelected.push(item);
          setListSelected([...listDataSelected]);
          dispatch(setGlobalCustomerReport([...listDataSelected]));
          return;
        }
        const isAllSelected = listSelected.includes(-1);

        if (isAllSelected) {
          const idFiltering = [-1];
          idFiltering.push(item?.id);
          const newList = listData.filter(
            (el) => !idFiltering.includes(el?.id)
          );
          setListSelected([...newList]);
          dispatch(setGlobalCustomerReport([...newList]));
          return;
        }
        const isExist = listSelected.some((el) => el?.id === item?.id);
        if (isExist) {
          const listDataFiltered = listSelected.filter(
            (el) => el?.id !== item?.id
          );
          setListSelected([...listDataFiltered]);
          dispatch(setGlobalCustomerReport([...listDataFiltered]));
          return;
        } else {
          const list = listSelected;
          list.unshift(item);
          setListSelected([...list]);
          dispatch(setGlobalCustomerReport([...list]));
          return;
        }
      }
    },
    [dispatch, listData, listSelected, totalData]
  );

  const isCheckedSelectAll = useMemo(() => {
    if (listSelected !== undefined && listSelected.length === totalData) {
      setIsSelectedAll(true);
      return true;
    }
    setIsSelectedAll(false);
    return false;
  }, [listSelected, totalData]);

  const isCheckedPerItem = useCallback(
    (item) => {
      if (listSelected.length > 0) {
        if (listSelected.length === totalData || listSelected.includes(-1)) {
          return true;
        }
        const isExist = listSelected.some((el) => el.id === item.id);
        return isExist;
      }
      return false;
    },
    [listSelected, totalData]
  );

  const isAllDepot = useMemo(() => {
    if (listSelected.length) {
      if (listSelected.includes(-1)) {
        return true;
      }
      const length = listSelected.length;
      if (listSelected.length > 0 && length === totalData) {
        return true;
      }
    }
    return false;
  }, [listSelected, totalData]);

  const onChangeSearch = useCallback((val) => {
    setSearchKeyword(val);
  }, []);

  useEffect(() => {
    if (!searchKeyword) {
      const resetParams = {
        page: 1,
        limit: 100,
        filter: "",
      };
      getListCustomer(resetParams);
      return;
    }
    const newParams = {
      page: 1,
      limit: 100,
      filter: `customer_name lk ${searchKeyword}`,
    };
    getListCustomer(newParams);
  }, [getListCustomer, searchKeyword]);

  useEffect(() => {
    if (isDepotHasValue) {
      const newParams = {
        page: 1,
        limit: 100,
      };
      getListCustomer(newParams);
      return;
    }
  }, [getListCustomer, globalDepotName, isDepotHasValue]);

  return (
    <div
      className={"dropdown-dds".concat(className ? ` ${className}` : "")}
      {...attrs}
      ref={dropdownRef}
    >
      <button
        className={`${
          isDepotHasValue ? "value-mss" : " value-mss-disabled"
        } `.concat(!isDepotHasValue ? " cursor-not-allowed" : "")}
        onClick={isDepotHasValue ? togglerDropdownContent : undefined}
        ref={btnDropdownRef}
      >
        {isAllDepot ? (
          <span className="list-value-mss">All Customer </span>
        ) : isCheckedSelectAll === false && listSelected.length !== 0 ? (
          listSelected.map((item, index) => (
            <span key={index} className="list-value-mss">
              {item?.cust_name}
            </span>
          ))
        ) : (
          <span className="placeholder-mss">Select Customer</span>
        )}
      </button>
      {!isDepotHasValue ? (
        <span className="font-roboto text-xs font-semibold text-red-100 mt-2">
          * Select Depot First
        </span>
      ) : (
        false
      )}
      <div></div>
      <div
        className={"dropdown-dds-menu".concat(
          isShowDropdownContent ? " active mt-2 pb-10" : ""
        )}
        ref={dropdownContentRef}
      >
        <div className="my-2 px-2">
          <Input
            placeholder="Search By Customer Name"
            size="large"
            suffix={<img src={IconSearch} alt="icon-search" />}
            onChange={(evt) => onChangeSearch(evt.target.value)}
          />
        </div>
        <div className="overflow-auto max-h-[300px]">
          {listData?.map((el, index) => (
            <div
              key={index}
              className={"dropdown-dds-item truncate"}
              onClick={() => handleClickSelectData(el)}
            >
              <div className="w-full flex justify-between px-2">
                <span>{el?.cust_name}</span>
                <Checkbox checked={isCheckedPerItem(el)} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MSSCustomerReport;
